import React, { useState } from "react";
import { FileGuard } from "../../utils/utils";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const iframeStyle = {
  width: "100%",
  height: "600px",
  border: "1px solid #ddd",
  borderRadius: "6px"
};

const NwkHtmlViewer = ({ trees }) => {
  const [selectedIndex, setSelectedIndex] = useState(0);

  if (!trees || trees.length === 0) return null;

  const selectedTree = trees[selectedIndex];

  return (
    <div>

      {/* Dropdown */}
      <div style={{ marginBottom: "15px" }}>
        <label style={{ marginRight: "10px" }}>
          Select Tree:
        </label>

        <select
          value={selectedIndex}
          onChange={(e) => setSelectedIndex(Number(e.target.value))}
        >
          {trees.map((tree, i) => (
            <option key={i} value={i}>
              {tree.name}
            </option>
          ))}
        </select>
      </div>

      {/* Tree File Link */}
      <div style={{ marginBottom: "10px" }}>
        <strong>Tree file:</strong>{" "}
          <FileGuard filePath={`${API_BASE_URL}/data/${selectedTree.nwk.file_path}`}>
            <a
              href={`${API_BASE_URL}/data/${selectedTree.nwk.file_path}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              {selectedTree.nwk.file_name}
            </a>
          </FileGuard>
      </div>

      {/* HTML Viewer */}
      {selectedTree.html && (
        <FileGuard filePath={`${API_BASE_URL}/data/${selectedTree.html.file_path}`}>
          <iframe
            src={`${API_BASE_URL}/data/${selectedTree.html.file_path}`}
            title={selectedTree.html.file_name}
            style={iframeStyle}
          />
        </FileGuard>
      )}
    </div>
  );
};

export default NwkHtmlViewer;
